import { DEFAULT_DESCRIPTION, DEFAULT_TITLE, SITE_URL } from './constants'

const JSON_LD_ATTR = 'data-seo-jsonld'

function upsertMeta(attr, key, content) {
  if (!content) return
  let el = document.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertLink(rel, href) {
  if (!href) return
  let el = document.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function normalizeCanonicalPath(path) {
  if (!path) return SITE_URL
  const [pathname] = path.split('?')
  const clean = pathname.replace(/\/+$/, '') || '/'
  return clean === '/' ? `${SITE_URL}/` : `${SITE_URL}${clean}/`
}

function clearJsonLd() {
  document.querySelectorAll(`script[${JSON_LD_ATTR}]`).forEach((node) => node.remove())
}

function injectJsonLd(schemas = []) {
  clearJsonLd()
  schemas.filter(Boolean).forEach((schema, index) => {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.setAttribute(JSON_LD_ATTR, String(index))
    script.textContent = JSON.stringify(schema)
    document.head.appendChild(script)
  })
}

/**
 * @param {Object} options
 * @param {string} options.title
 * @param {string} [options.description]
 * @param {string} [options.path] - route path for canonical
 * @param {string} [options.image]
 * @param {boolean} [options.noindex]
 * @param {Object|Object[]} [options.jsonLd]
 */
export function applyPageSeo({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = '/',
  image,
  noindex = false,
  jsonLd = [],
} = {}) {
  document.title = title
  document.documentElement.lang = 'zh-CN'

  upsertMeta('name', 'description', description)
  upsertLink('canonical', normalizeCanonicalPath(path))

  upsertMeta('property', 'og:title', title)
  upsertMeta('property', 'og:description', description)
  upsertMeta('property', 'og:url', normalizeCanonicalPath(path))
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:locale', 'zh_CN')
  if (image) {
    const abs = /^https?:\/\//i.test(image) ? image : `${SITE_URL}${image.startsWith('/') ? image : `/${image}`}`
    upsertMeta('property', 'og:image', abs)
    upsertMeta('property', 'og:image:secure_url', abs)
    upsertMeta('itemprop', 'image', abs)
    upsertMeta('name', 'twitter:card', 'summary_large_image')
    upsertMeta('name', 'twitter:image', abs)
  }

  if (noindex) {
    upsertMeta('name', 'robots', 'noindex, nofollow')
  } else {
    const robots = document.querySelector('meta[name="robots"]')
    if (robots) robots.remove()
  }

  const schemas = Array.isArray(jsonLd) ? jsonLd : [jsonLd]
  if (schemas.length) injectJsonLd(schemas)
}

export function applyGlobalSeo(jsonLd = []) {
  injectJsonLd(jsonLd)
}
